import { useContext, useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { NewSidebareCommercial } from "../../NewSideBareCommercial";
import { MagasinContext } from "../../../Context/MagasinContext";
import axios from "axios";

const S = {
  page: { minHeight: "100vh", background: "linear-gradient(135deg,#f8faff 0%,#f1f5fb 100%)", paddingBottom: "60px" } as React.CSSProperties,
  inner: { maxWidth: "820px", margin: "0 auto", padding: "32px 18px 0" } as React.CSSProperties,
  card: { background: "#fff", borderRadius: "20px", boxShadow: "0 4px 24px rgba(0,0,0,0.07)", marginBottom: "20px", overflow: "hidden" } as React.CSSProperties,
  cardHead: { padding: "18px 24px", background: "linear-gradient(135deg,#1a1a2e,#16213e)", color: "#fff", fontWeight: 700, fontSize: "0.95rem", display: "flex", alignItems: "center", gap: "10px" } as React.CSSProperties,
  cardBody: { padding: "24px" } as React.CSSProperties,
  row: { display: "flex", gap: "16px", flexWrap: "wrap" as const, marginBottom: "16px" } as React.CSSProperties,
  formGroup: { display: "flex", flexDirection: "column" as const, flex: 1, minWidth: "220px" } as React.CSSProperties,
  label: { fontSize: "0.78rem", fontWeight: 700, color: "#64748b", marginBottom: "6px", textTransform: "uppercase" as const, letterSpacing: "0.05em" } as React.CSSProperties,
  input: { padding: "10px 14px", border: "1.5px solid #e2e8f0", borderRadius: "10px", fontSize: "0.92rem", color: "#1e293b", outline: "none", transition: "border 0.2s", background: "#fff" } as React.CSSProperties,
  inputReadOnly: { padding: "10px 14px", border: "1.5px solid #f1f5f9", borderRadius: "10px", fontSize: "0.92rem", color: "#94a3b8", background: "#f8fafc" } as React.CSSProperties,
  saveBtn: { background: "linear-gradient(135deg,#F5A623,#e8930c)", color: "#1a1a2e", border: "none", padding: "12px 32px", borderRadius: "12px", fontWeight: 700, fontSize: "0.92rem", cursor: "pointer", transition: "all 0.2s", display: "flex", alignItems: "center", gap: "8px" } as React.CSSProperties,
  linkBtn: { display: "flex", alignItems: "center", justifyContent: "space-between", padding: "14px 18px", borderRadius: "12px", border: "1.5px solid #e2e8f0", marginBottom: "10px", cursor: "pointer", transition: "all 0.2s", textDecoration: "none", color: "#1e293b", background: "#fff" } as React.CSSProperties,
  badge: { display: "inline-block", padding: "4px 12px", borderRadius: "20px", fontSize: "0.82rem", fontWeight: 700, background: "linear-gradient(135deg,#F5A623,#e8930c)", color: "#1a1a2e" } as React.CSSProperties,
};

export default function SettingCommercial() {
  const magasinContext = useContext(MagasinContext);
  const CommercialId = localStorage.getItem("CommercialId");
  const id = CommercialId || magasinContext.id?.id;
  const navigate = useNavigate();

  const [nom, setNom] = useState("");
  const [nomEditable, setNomEditable] = useState("");
  const [email, setEmail] = useState("");
  const [solde, setSolde] = useState<number | null>(null);
  const [remise, setRemise] = useState<string | null>(null);
  const [magasinLie, setMagasinLie] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [toast, setToast] = useState<{ msg: string; ok: boolean } | null>(null);

  const [showEmailModal, setShowEmailModal] = useState(false);
  const [showPasswordModal, setShowPasswordModal] = useState(false);
  const [newEmailInput, setNewEmailInput] = useState("");
  const [newPasswordInput, setNewPasswordInput] = useState("");
  const [submittingSecurity, setSubmittingSecurity] = useState(false);

  useEffect(() => {
    if (!id) { setLoading(false); return; }
    const idMagasin = localStorage.getItem("magasin_connecte") || "";
    const profileUrl = `${process.env.REACT_APP_PHP_APP_URL}/commercial/${id}/profile${idMagasin ? `?idMagasin=${idMagasin}` : ""}`;
    axios.get(profileUrl)
      .then((res) => {
        const c = res.data?.commercial ?? res.data;
        if (c) {
          const fullName = ((c.Nom ?? "") + " " + (c.Prenom ?? "")).trim();
          setNom(fullName);
          setNomEditable(fullName);
          setEmail(c.Email ?? "");
          // Use localStorage solde (per-magasin, set at login) if available
          const lsSolde = localStorage.getItem("SoldeCommercial");
          setSolde(lsSolde ? (parseFloat(lsSolde) || 0) : (parseFloat(c.Credit ?? c.credit ?? "0") || 0));
          // Use localStorage remise (per-magasin, set at login) - it's more accurate than global profile
          const lsRemise = localStorage.getItem("remise");
          setRemise(lsRemise ?? c.RemiseGlobal ?? null);
        }
        if (res.data?.magasin) setMagasinLie(res.data.magasin.name ?? null);
      })
      .catch(() => {
        const fallbackName = localStorage.getItem("CommercialName") ?? "";
        setNom(fallbackName);
        setNomEditable(fallbackName);
        setMagasinLie(localStorage.getItem("MagasinName") ?? null);
        const s = parseFloat(localStorage.getItem("SoldeCommercial") ?? "0");
        setSolde(isNaN(s) ? 0 : s);
      })
      .finally(() => setLoading(false));
  }, [id]);

  const showToast = (msg: string, ok: boolean) => {
    setToast({ msg, ok });
    setTimeout(() => setToast(null), 3500);
  };

  const handleSave = async () => {
    if (saving) return;
    setSaving(true);
    try {
      const fd = new FormData();
      fd.append("Nom", nomEditable);
      await axios.post(`${process.env.REACT_APP_PHP_APP_URL}/commercial/${id}/update-profile`, fd);
      setNom(nomEditable);
      localStorage.setItem("CommercialName", nomEditable);
      showToast("Profil mis à jour avec succès ✓", true);
    } catch {
      showToast("Erreur lors de la mise à jour", false);
    } finally {
      setSaving(false);
    }
  };

  const handleSecurityRequest = (type: "change-email" | "change-mot-de-passe") => {
    if (type === "change-email" && !newEmailInput.trim()) return;
    if (type === "change-mot-de-passe" && !newPasswordInput.trim()) return;
    setSubmittingSecurity(true);
    axios.post(`${process.env.REACT_APP_PHP_APP_URL}/commercial/${id}/security-request`, {
      demande: type,
      new_email: type === "change-email" ? newEmailInput : null,
      new_password: type === "change-mot-de-passe" ? newPasswordInput : null,
      userName: nom || "Commercial",
      currentEmail: email || "",
    }).then(() => {
      showToast("Demande envoyée — en attente de validation par l'admin.", true);
      setShowEmailModal(false);
      setShowPasswordModal(false);
      setNewEmailInput("");
      setNewPasswordInput("");
    }).catch(() => {
      showToast("Erreur lors de l'envoi de la demande.", false);
    }).finally(() => setSubmittingSecurity(false));
  };

  if (loading) {
    return (
      <div style={S.page}>
        <NewSidebareCommercial />
        <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "60vh" }}>
          <div className="spinner-border text-warning" />
        </div>
      </div>
    );
  }

  return (
    <div style={S.page}>
      <NewSidebareCommercial />

      {toast && (
        <div style={{ position: "fixed", top: "24px", right: "24px", zIndex: 9999, background: toast.ok ? "#d4edda" : "#f8d7da", color: toast.ok ? "#155724" : "#721c24", padding: "14px 22px", borderRadius: "14px", fontWeight: 700, fontSize: "0.9rem", boxShadow: "0 4px 16px rgba(0,0,0,0.12)" }}>
          {toast.msg}
        </div>
      )}

      <div style={S.inner}>
        <button onClick={() => window.history.back()} style={{ background: "none", border: "none", cursor: "pointer", color: "#64748b", fontWeight: 600, marginBottom: "20px", display: "flex", alignItems: "center", gap: "6px" }}>
          ← Retour
        </button>
        <h1 style={{ fontFamily: "'Inter', sans-serif", fontWeight: 800, fontSize: "1.6rem", color: "#1e293b", marginBottom: "24px" }}>
          Paramètres du compte
        </h1>

        {/* PROFILE CARD */}
        <div style={S.card}>
          <div style={S.cardHead}>
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#F5A623" strokeWidth="2.5">
              <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" /><circle cx="12" cy="7" r="4" />
            </svg>
            Informations du profil
          </div>
          <div style={S.cardBody}>
            <div style={{ fontWeight: 700, fontSize: "1.1rem", color: "#1e293b", marginBottom: "4px" }}>{nom || "—"}</div>
            <div style={{ color: "#64748b", fontSize: "0.85rem", marginBottom: "24px" }}>{email}</div>
            <div style={S.row}>
              <div style={S.formGroup}>
                <label style={S.label}>Nom complet</label>
                <input
                  style={S.input}
                  value={nomEditable}
                  onChange={(e) => setNomEditable(e.target.value)}
                  placeholder="Votre nom complet..."
                  onFocus={(e) => (e.target.style.border = "1.5px solid #F5A623")}
                  onBlur={(e) => (e.target.style.border = "1.5px solid #e2e8f0")}
                />
              </div>
            </div>
            <div style={{ display: "flex", justifyContent: "flex-end", marginTop: "8px" }}>
              <button style={S.saveBtn} onClick={handleSave} disabled={saving}>
                {saving ? <><span className="spinner-border spinner-border-sm" /> Enregistrement...</> : <><i className="bi bi-floppy-fill"></i> Enregistrer</>}
              </button>
            </div>
          </div>
        </div>

        {/* READ-ONLY INFO */}
        <div style={S.card}>
          <div style={S.cardHead}>
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#F5A623" strokeWidth="2.5">
              <circle cx="12" cy="12" r="10" /><line x1="12" y1="8" x2="12" y2="12" /><line x1="12" y1="16" x2="12.01" y2="16" />
            </svg>
            Informations du compte
          </div>
          <div style={S.cardBody}>
            <div style={S.row}>
              <div style={S.formGroup}>
                <label style={S.label}>Email</label>
                <div style={S.inputReadOnly}>{email || "—"}</div>
              </div>
              <div style={S.formGroup}>
                <label style={S.label}>Magasin lié</label>
                <div style={S.inputReadOnly}>{magasinLie || localStorage.getItem("MagasinName") || "—"}</div>
              </div>
            </div>
            <div style={S.row}>
              <div style={S.formGroup}>
                <label style={S.label}>Solde disponible</label>
                <div style={{ ...S.inputReadOnly, background: "linear-gradient(135deg,#1a1a2e,#16213e)", color: "#F5A623", fontWeight: 800, fontSize: "1.05rem" }}>
                  {solde != null ? solde.toLocaleString("fr-FR", { minimumFractionDigits: 2 }) + " MAD" : "—"}
                </div>
              </div>
              <div style={S.formGroup}>
                <label style={S.label}>Remise globale</label>
                <div style={S.inputReadOnly}>{remise != null ? remise : localStorage.getItem("remise") ?? "—"}</div>
              </div>
            </div>
          </div>
        </div>

        {/* SECURITY */}
        <div style={S.card}>
          <div style={S.cardHead}>
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#F5A623" strokeWidth="2.5">
              <rect x="3" y="11" width="18" height="11" rx="2" ry="2" /><path d="M7 11V7a5 5 0 0 1 10 0v4" />
            </svg>
            Sécurité
          </div>
          <div style={S.cardBody}>
            <div role="button" tabIndex={0} onClick={() => setShowEmailModal(true)} onKeyDown={(e) => e.key === "Enter" && setShowEmailModal(true)} style={{ ...S.linkBtn, cursor: "pointer" }} onMouseOver={(e) => (e.currentTarget.style.background = "#f8fafc")} onMouseOut={(e) => (e.currentTarget.style.background = "#fff")}>
              <span style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                <span style={{ width: "36px", height: "36px", borderRadius: "10px", background: "#f1f5f9", display: "flex", alignItems: "center", justifyContent: "center" }}>
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#64748b" strokeWidth="2.5"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" /><polyline points="22,6 12,13 2,6" /></svg>
                </span>
                <span>
                  <div style={{ fontWeight: 600, fontSize: "0.9rem" }}>Changer l'adresse email</div>
                  <div style={{ fontSize: "0.78rem", color: "#94a3b8" }}>{email || "—"}</div>
                </span>
              </span>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#94a3b8" strokeWidth="2.5"><polyline points="9 18 15 12 9 6" /></svg>
            </div>
            <div role="button" tabIndex={0} onClick={() => setShowPasswordModal(true)} onKeyDown={(e) => e.key === "Enter" && setShowPasswordModal(true)} style={{ ...S.linkBtn, cursor: "pointer" }} onMouseOver={(e) => (e.currentTarget.style.background = "#f8fafc")} onMouseOut={(e) => (e.currentTarget.style.background = "#fff")}>
              <span style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                <span style={{ width: "36px", height: "36px", borderRadius: "10px", background: "#f1f5f9", display: "flex", alignItems: "center", justifyContent: "center" }}>
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#64748b" strokeWidth="2.5"><rect x="3" y="11" width="18" height="11" rx="2" ry="2" /><path d="M7 11V7a5 5 0 0 1 10 0v4" /></svg>
                </span>
                <span>
                  <div style={{ fontWeight: 600, fontSize: "0.9rem" }}>Changer le mot de passe</div>
                  <div style={{ fontSize: "0.78rem", color: "#94a3b8"}}>••••••••</div>
                </span>
              </span>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#94a3b8" strokeWidth="2.5"><polyline points="9 18 15 12 9 6" /></svg>
            </div>
          </div>
        </div>
      </div>

      {/* Modal: change email */}
      {showEmailModal && (
        <div style={{ position: "fixed", top: 0, left: 0, width: "100%", height: "100%", background: "rgba(0,0,0,0.55)", zIndex: 2000, display: "flex", justifyContent: "center", alignItems: "center" }}>
          <div style={{ background: "#fff", padding: "28px 28px 24px", borderRadius: "14px", width: "420px", maxWidth: "92%", boxShadow: "0 8px 40px rgba(0,0,0,0.18)" }}>
            <h3 style={{ margin: "0 0 8px", fontSize: "1.15rem", fontWeight: 700 }}>Changer l'adresse email</h3>
            <p style={{ fontSize: "0.88rem", color: "#64748b", marginBottom: "20px", lineHeight: 1.5 }}>
              Cette demande sera soumise à l'administrateur pour validation.
            </p>
            <label style={{ fontWeight: 600, fontSize: "0.82rem", color: "#64748b", marginBottom: "6px", display: "block" }}>Nouvelle adresse email</label>
            <input type="email" value={newEmailInput} onChange={(e) => setNewEmailInput(e.target.value)} placeholder="ex: nouveau@email.com" style={{ width: "100%", padding: "10px 14px", border: "1.5px solid #e2e8f0", borderRadius: "8px", fontSize: "0.92rem", marginBottom: "20px", outline: "none", boxSizing: "border-box", color:"black" }} />
            <div style={{ display: "flex", justifyContent: "flex-end", gap: "10px" }}>
              <button onClick={() => { setShowEmailModal(false); setNewEmailInput(""); }} style={{ padding: "9px 20px", borderRadius: "8px", border: "1.5px solid #e2e8f0", background: "#f8fafc", color: "#64748b", fontWeight: 600, cursor: "pointer", fontSize: "0.9rem" }}>Annuler</button>
              <button onClick={() => handleSecurityRequest("change-email")} disabled={submittingSecurity || !newEmailInput.trim()} style={{ padding: "9px 20px", borderRadius: "8px", border: "none", background: "#F5A623", color: "#1a1a2e", fontWeight: 700, cursor: "pointer", fontSize: "0.9rem", opacity: (!newEmailInput.trim() || submittingSecurity) ? 0.6 : 1 }}>
                {submittingSecurity ? "Envoi..." : "Envoyer la demande"}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modal: change password */}
      {showPasswordModal && (
        <div style={{ position: "fixed", top: 0, left: 0, width: "100%", height: "100%", background: "rgba(0,0,0,0.55)", zIndex: 2000, display: "flex", justifyContent: "center", alignItems: "center" }}>
          <div style={{ background: "#fff", padding: "28px 28px 24px", borderRadius: "14px", width: "420px", maxWidth: "92%", boxShadow: "0 8px 40px rgba(0,0,0,0.18)" }}>
            <h3 style={{ margin: "0 0 8px", fontSize: "1.15rem", fontWeight: 700 }}>Changer le mot de passe</h3>
            <p style={{ fontSize: "0.88rem", color: "#64748b", marginBottom: "20px", lineHeight: 1.5 }}>
              Cette demande sera soumise à l'administrateur pour validation.
            </p>
            <label style={{ fontWeight: 600, fontSize: "0.82rem", color: "#64748b", marginBottom: "6px", display: "block" }}>Nouveau mot de passe</label>
            <input type="password" value={newPasswordInput} onChange={(e) => setNewPasswordInput(e.target.value)} placeholder="Entrez votre nouveau mot de passe" style={{ width: "100%", padding: "10px 14px", border: "1.5px solid #e2e8f0", borderRadius: "8px", fontSize: "0.92rem", marginBottom: "20px", outline: "none", boxSizing: "border-box" , color:"black" }} />
            <div style={{ display: "flex", justifyContent: "flex-end", gap: "10px" }}>
              <button onClick={() => { setShowPasswordModal(false); setNewPasswordInput(""); }} style={{ padding: "9px 20px", borderRadius: "8px", border: "1.5px solid #e2e8f0", background: "#f8fafc", color: "#64748b", fontWeight: 600, cursor: "pointer", fontSize: "0.9rem" }}>Annuler</button>
              <button onClick={() => handleSecurityRequest("change-mot-de-passe")} disabled={submittingSecurity || !newPasswordInput.trim()} style={{ padding: "9px 20px", borderRadius: "8px", border: "none", background: "#F5A623", color: "#1a1a2e", fontWeight: 700, cursor: "pointer", fontSize: "0.9rem", opacity: (!newPasswordInput.trim() || submittingSecurity) ? 0.6 : 1 }}>
                {submittingSecurity ? "Envoi..." : "Envoyer la demande"}
              </button>
            </div>
          </div>
        </div>
      )}

      <style>{`@keyframes slideInRight { from { opacity: 0; transform: translateX(40px); } to { opacity: 1; transform: translateX(0); } }`}</style>
    </div>
  );
}